var SENTRY_RELEASE;SENTRY_RELEASE={name: "Vocalise Dev", version: "0.24.10-rc.3"};